export default __webpack_public_path__ + "static/media/Edit-all-blue.a2245146.svg";